import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export const FolderIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} width="33" height="30" viewBox="0 0 33 30" fill="none">
      <svg width="33" height="30" viewBox="0 0 38 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_260_210)">
          <path
            d="M28.04 6.15999H17.97C17.25 6.15999 16.55 5.89999 16 5.41999L11.76 1.72999C11.21 1.25999 10.52 0.98999 9.79 0.98999H3.99C2.33 0.98999 0.99 2.32999 0.99 3.98999V25.14C0.99 26.8 2.33 28.14 3.99 28.14H28.03C29.69 28.14 31.03 26.8 31.03 25.14V9.13999C31.03 7.47999 29.69 6.13999 28.03 6.13999L28.04 6.15999Z"
            strokeWidth="2"
            strokeMiterlimit="10"
          />
          <path d="M10.44 17.36H21.6" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" />
          <path d="M16.02 22.95V11.78" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" />
        </g>
        <defs>
          <clipPath id="clip0_260_210">
            <rect width="32.04" height="29.15" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
};
